import React, {FC} from 'react';

import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import {getLoginContent} from '@/services/content/appContent.typed';

const LoginErrorAlert: FC = () => {
    const {wrongCredentialsWarning} = getLoginContent();
    const {title, path} = wrongCredentialsWarning || {};

    if (!title) return null;

    return (
        <div role='alert' className='flex w-full items-center gap-6 rounded bg-secondary px-6 py-5'>
            <RemoteIconV2 icon={{path}} className='h-6 w-6 shrink-0' />
            <span className='leading-14_3 flex-1 text-start text-14 tracking-04 text-primary'>{title}</span>
        </div>
    );
};

export default LoginErrorAlert;
